<template>

  <div class="page-home">
  
    <ModalForm></ModalForm>
    <div id="fp">
      <div class="section section1">
        <Top></Top>
        <div class="uk-section uk-section-small uk-section-default">
          <div class="uk-container uk-container-large uk-margin">
            <div class="uk-grid uk-text-center " uk-grid v-if="media=='l'">
                <div class="uk-width-1-5 "  v-bind:class="{'uk-animation-slide-left':pageIndex==1,'uk-hidden':pageIndex!=1}" >
                  <div class="uk-padding-small uk-padding-remove-vertical">
                    <img src="../assets/images/left.png"/>
                  </div>
                </div>
                <div class="uk-width-3-5 uk-padding-small uk-padding-remove-vertical" v-bind:class="{'uk-animation-fade':pageIndex==1,'uk-hidden':pageIndex!=1}">
                    <div class="uk-card uk-card-default uk-cover-container uk-height-1-1  uk-box-shadow-large uk-border-rounded">
                          <video data-autoplay uk-cover autoplay loop muted class="uk-height-1-1"> 
                              <source src="https://img.file.artsdoor.org/yidaointro.mp4"  type="video/mp4">
                          </video>
                    </div>
                </div>
                <div class="uk-width-1-5" v-bind:class="{'uk-animation-slide-right':pageIndex==1,'uk-hidden':pageIndex!=1}">
                  <div class="uk-padding-small uk-padding-remove-vertical">
                    <img src="../assets/images/right.png"/>
                  </div>
                </div>
            </div>
            <div class="uk-container uk-container-small uk-padding-small" v-if="media=='l'"  style="animation-delay: .5s;" v-bind:class="{'uk-animation-fade':pageIndex==1,'uk-hidden':pageIndex!=1}">
              <h1 class="uk-h1 uk-text-center"><span>音悦艺道</span></h1>
              <!--<hr class=" uk-margin-large uk-margin-remove-top uk-divider-small uk-text-center"></hr>-->
              <h3 class="uk-h3 uk-text-center "><span>为您提供中国传统音乐和西方古典音乐精品教育资源、赏析资源</span></h3>
            </div>

            <!--mobile-->
            <div class="uk-text-center" v-if="media=='m'" v-bind:class="{'uk-animation-fade':pageIndex==1,'uk-hidden':pageIndex!=1}">
                    <div class="uk-card  uk-card-default  uk-width1-1  uk-box-shadow-large uk-border-rounded">
                          <video data-autoplay  autoplay loop muted class=" uk-width1-1 uk-border-rounded" > 
                              <source src="https://img.file.artsdoor.org/yidaointro.mp4" type="video/mp4">
                          </video>
                    </div>
            </div>
          </div>
          <div class="uk-container uk-container-small uk-padding-small" v-if="media=='m'" style="animation-delay: .5s;" v-bind:class="{'uk-animation-fade':pageIndex==1,'uk-hidden':pageIndex!=1}">
            <h1 class="uk-h2 uk-text-center"><span>音悦艺道</span></h1>
            <!--<hr class=" uk-margin-large uk-margin-remove-top uk-divider-small uk-text-center"></hr>-->
            <h3 class="uk-h3 uk-text-center "><span>为您提供中国传统音乐和西方古典音乐精品教育资源、赏析资源</span></h3>
          </div>

      </div>
    </div>

    <div class="section section2">
        <div class="uk-height-1-1"  v-bind:class="{'uk-section uk-section-small uk-section-default ':media=='l','uk-padding-small':media=='m'}">
          <div class="uk-height-1-1" v-bind:class="{'uk-container  uk-container-expand ':media=='l'}">
              <div class="card-bg uk-card uk-card-default uk-width-1-1 uk-inline uk-card-body uk-height-1-1 uk-background-cover uk-background-norepeat  uk-box-shadow-large uk-border-rounded ">
                  <div class="uk-position-center" v-bind:class="{'uk-padding-small':media=='m'}">
                    <div v-bind:class="{'uk-animation-fade':pageIndex==2,'uk-hidden':pageIndex!=2}" v-html="activeMsg"></div>
                    <div class="uk-grid uk-padding  uk-text-center" uk-grid>
                        <div  v-bind:class="{ 'uk-width-1-2':media=='m','uk-width-1-4':media=='l',active: activeTab == 1,'uk-animation-slide-left':pageIndex==2,'uk-hidden':pageIndex!=2 }" >
                            <div class="uk-card uk-card-hover " @click="clickTab(1)">
                              <img class="uk-border-circle" src="../assets/images/liao.png">
                              <h4 class="uk-margin">廖昌永</h4>
                            </div>
                        </div>
                        <div style="animation-delay: .3s;" v-bind:class="{ 'uk-width-1-2':media=='m','uk-width-1-4':media=='l', active: activeTab == 2 ,'uk-animation-slide-left':pageIndex==2,'uk-hidden':pageIndex!=2 }">
                            <div class="uk-card uk-card-hover" @click="clickTab(2)">
                              <img class="uk-border-circle" src="../assets/images/luo.png">
                              <h4 class="uk-margin">罗魏</h4>
                            </div>
                        </div>
                        <div  style="animation-delay: .6s;"  v-bind:class="{'uk-width-1-2':media=='m','uk-width-1-4':media=='l',active: activeTab == 3,'uk-animation-slide-left':pageIndex==2,'uk-hidden':pageIndex!=2  }">
                            <div class="uk-card uk-card-hover  " @click="clickTab(3)">
                              <img class="uk-border-circle" src="../assets/images/zhou.png">
                              <h4 class="uk-margin">周温玉</h4>
                            </div>
                        </div>
                        <div  style="animation-delay: .9s;" v-bind:class="{'uk-width-1-2':media=='m','uk-width-1-4':media=='l',active: activeTab == 4,'uk-animation-slide-left':pageIndex==2,'uk-hidden':pageIndex!=2  }">
                            <div class="uk-card uk-card-hover " @click="clickTab(4)">
                              <img class="uk-border-circle" src="../assets/images/wang.png">
                              <h4 class="uk-margin">汪任酩</h4>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div class="section section3">
        <div class="uk-section uk-section uk-section-default">
            <div class="uk-container uk-container-small"  v-bind:class="{ 'uk-animation-scale-up':pageIndex==3,'uk-hidden':pageIndex!=3 }">
              <h1 class="uk-h1 uk-text-center"><span>我们提供的课程</span></h1>
            </div>
          <div class="uk-container " v-bind:class="{'uk-margin-large-top':media=='l','uk-margin-top':media=='m'}">
                  <div class="uk-grid uk-grid-small" uk-grid v-bind:class="{'uk-child-width-1-4':media=='l','uk-child-width-1-2':media=='m'}">
                      <div>
                        <div class="uk-card uk-text-center uk-card-hover uk-border-rounded"  v-bind:class="{'uk-padding-small':media=='l', 'uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }" id="card-1" v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                            <div class="uk-card-media-top">
                                <div class="livicon-evo uk-align-center" v-bind:data-options="'name:thumbnails-big;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                            </div>
                            <div class="">
                                <h4 class="uk-card-title">声乐课程</h4>
                                <p>声乐课程</p>
                            </div>
                        </div>
                      </div>
                      <div>
                        <div class="uk-card  uk-text-center uk-card-hover uk-border-rounded" id="card-2" style="animation-delay: .2s;"   v-bind:class="{ 'uk-padding-small':media=='l','uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }"  v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                          <div class="uk-card-media-top">
                                <div class="livicon-evo uk-align-center" v-bind:data-options="'name:thumbnails-big;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                            </div>
                            <div class="">
                                <h3 class="uk-card-title">钢琴课程</h3>
                                <p>钢琴课程</p>
                            </div>
                        </div>
                      </div>
                      <div>
                      <div class="uk-card uk-text-center uk-card-hover uk-border-rounded" id="card-3" style="animation-delay: .4s;"   v-bind:class="{'uk-padding-small':media=='l', 'uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }"  v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                        <div class="uk-card-media-top">
                                <div class="livicon-evo uk-align-center" v-bind:data-options="'name:thumbnails-big;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                            </div>
                            <div class="">
                                <h3 class="uk-card-title">管乐课程</h3>
                                <p>管乐课程</p>
                            </div>
                        </div>
                      </div>
                      <div>
                      <div class="uk-card uk-text-center uk-card-hover uk-border-rounded" id="card-4" style="animation-delay: .6s;"   v-bind:class="{'uk-padding-small':media=='l', 'uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }"  v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                        <div class="uk-card-media-top">
                              <div class="livicon-evo uk-align-center" v-bind:data-options="'name:thumbnails-big;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                          </div>
                          <div class="">
                              <h3 class="uk-card-title">弦乐课程</h3>
                              <p>弦乐课程</p>
                          </div>
                        </div>
                      </div>
                  </div>
                  <div class="uk-grid uk-grid-small uk-grid2" uk-grid  v-bind:class="{'uk-child-width-1-4':media=='l','uk-child-width-1-2':media=='m'}">
                      <div>
                        <div class="uk-card uk-text-center uk-card-hover uk-border-rounded" id="card-5" style="animation-delay: .8s;"   v-bind:class="{'uk-padding-small':media=='l', 'uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }"  v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                            <div class="uk-card-media-top">
                                <div class="livicon-evo uk-align-center" v-bind:data-options="'name:thumbnails-big;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                            </div>
                            <div class="">
                                <h3 class="uk-card-title">视唱练耳课程</h3>
                                <p>视唱练耳课程</p>
                            </div>
                        </div>
                      </div>
                      <div>
                        <div class="uk-card uk-text-center uk-card-hover uk-border-rounded" id="card-6" style="animation-delay: 1s;"   v-bind:class="{ 'uk-padding-small':media=='l','uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }"  v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                          <div class="uk-card-media-top">
                                <div class="livicon-evo uk-align-center" v-bind:data-options="'name:thumbnails-big;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                            </div>
                            <div class="">
                                <h3 class="uk-card-title">打击乐课程</h3>
                                <p>打击乐课程<br/></p>
                            </div>
                        </div>
                      </div>
 
                      <div> 
                      <div class="uk-card uk-text-center uk-card-hover uk-border-rounded" id="card-8" style="animation-delay: 1.4s;"   v-bind:class="{ 'uk-padding-small':media=='l','uk-animation-fade':pageIndex==3,'uk-hidden':pageIndex!=3 }"  v-on:mouseenter="hoverIconCard($event)" v-on:mouseleave="mouseOutCard($event)">
                        <div class="uk-card-media-top">
                              <div class="livicon-evo uk-align-center" v-bind:data-options="'name:more;'+(media=='m'?iconOptions_m:iconOptions)"></div>
                          </div>
                          <div class="">
                              <h3 class="uk-card-title">持续更新</h3>
                              <p></p>
                          </div>
                        </div>
                      </div>
                  </div>
          </div>
        </div>
    </div>

    <div class="section section4">
        <div class="uk-section uk-section-small uk-section-default uk-height-1-1">
          <div class="uk-container uk-container-expand  uk-height-1-1 ">
              <div class="card-bg uk-card uk-card-default uk-width-1-1  uk-card-body uk-height-1-1  uk-box-shadow-xlarge uk-border-rounded ">
                <h1 class="uk-h1 uk-text-center uk-margin-medium-top" v-bind:class="{ 'uk-animation-slide-top':pageIndex==4,'uk-hidden':pageIndex!=4 }"><span>联系我们</span></h1>
                <div class="uk-position-center uk-width-2-3@m uk-width-1-1 uk-text-center">
                  <div class="uk-inline" v-bind:class="{ 'uk-animation-scale-up':pageIndex==4,'uk-hidden':pageIndex!=4 }" >
                      <img src="../assets/images/footer.png">
                      <div class="address-card uk-card uk-card-default uk-padding uk-box-shadow-xlarge uk-border-rounded  uk-overlay uk-overlay-default  uk-text-left uk-text-break" v-bind:class="{'uk-width-2-5 uk-position-center-right':media=='l','uk-width-1-2 uk-position-center':media=='m'}">
                          <h4 class="uk-text-bold">音悦艺道</h4>
                          <p class="uk-text-bold">沪青平公路3938弄移动智地42号音悦艺道国际艺术交流中心<br/>
                            上海市青浦区<br/>
                            <i class="iconfont icon-phone"></i> 021-59888338 <br/>
                            <i class="iconfont icon-xin"></i> info@artsong.cn <br/>
                          </p>
                          <a class="uk-button uk-button-primary uk-border-rounded" href="https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAMAAJTemFpUNDVNMUtNOEtPWTRZUldDMks3WUxFQjU5Sy4u"  uk-toggle>留言寻求支持和帮助</a>
                      </div>
                      <div class="uk-position-center position-marker">
                          <img src="../assets/images/fancy-marker.png">
                      </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="copyright uk-container uk-text-center uk-text-bold">
            <p>Copyright © 2016-2022 <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备16054728号-4</a></p>
          </div>
        </div>
        
    </div>
    </div>
  </div>
</template>

<script>

// import '../assets/js/fullpage/fullpage.dragAndMove.limited.min.js';
import '../assets/js/fullpage/jquery.fullpage.min.js';

import Top from '../components/Top'

export default {
  name: 'home',
  components:{
    Top
  },
  data () {
    return {
      media:'',
      iconOptions:"size:80px; style:filled;eventOn:grandparent; morphState:start; strokeColor:#818181;fillColor:#C9C9C9;strokeColorAction:#6D8C9E;fillColorAction:#b5dbe5;colorsOnHover:custom;colorsHoverTime:1;",
      iconOptions_m:"size:50px; style:filled;eventOn:grandparent; morphState:start; strokeColor:#818181;fillColor:#C9C9C9;strokeColorAction:#6D8C9E;fillColorAction:#b5dbe5;colorsOnHover:custom;colorsHoverTime:1;",
      activeTab: 1, //section2
      activeMsg:  '<div class="uk-animation-fade"><h2 class="uk-h2 uk-text-center uk-width-1-1 "><span>音悦艺道</span></h2>'+
                  '<p class="uk-text-center uk-width-1-1"><span>音悦艺道是一个专注中国传统音乐和西方古典音乐领域的互联网移动应用</span></p>'+
				  '<p class="uk-text-center uk-width-1-1"><span>通过顶级艺术家系统化教学课程和精品赏析原创内容</span></p>'+
                  '<p class="uk-text-center uk-width-1-1"><span>借助互联网模打造经典音乐“教与学”、“欣赏与分享”的内容平台</span></p></div>',
      pageIndex: 1
    }
  },
  methods: {
    responseFunc:function(){
        var that = this;
        if (window.innerWidth > 960) {
            that.media='l';
        } else if (window.innerWidth <= 960) {
            that.media='m';
        } 
    },
    clickTab: function (val) {
      var that = this;
      switch(val){
        case 1:
            that.activeTab = 1;
            that.activeMsg =  '<div class="uk-animation-fade"><h2 class="uk-h2 uk-text-center uk-width-1-1"><span>廖昌永</span></h2>'+
                              '<p class="uk-text-center uk-width-1-1"><span>中国当代最杰出男中音歌唱家</span></p>'+
                              '</div>';
            break;
        case 2:
            that.activeTab = 2;
            that.activeMsg =  '<div class="uk-animation-fade"><h2 class="uk-h2 uk-text-center uk-width-1-1"><span>罗魏</span></h2>'+
                              '<p class="uk-text-center uk-width-1-1"><span>资历深厚的歌唱家和声乐教育家</span></p>'+
                              '</div>';
            break;
        case 3:
            that.activeTab = 3;
            that.activeMsg =  '<div class="uk-animation-fade"><h2 class="uk-h2 uk-text-center uk-width-1-1"><span>周温玉</span></h2>'+
                              '<p class="uk-text-center uk-width-1-1"><span>上海音乐学院作曲系教授，硕士生导师</span></p>'+
                              '</div>';
            break;
        case 4:
            that.activeTab = 4;
            that.activeMsg =  '<div class="uk-animation-fade"><h2 class="uk-h2 uk-text-center uk-width-1-1"><span>汪任酩</span></h2>'+
                              '<p class="uk-text-center uk-width-1-1"><span>毕业于上海音乐学院声乐系，师从周小燕教授</span></p>'+
                              '</div>';
            break;
      }
    },
    hoverIconCard: function(event){
      var that = this;
      var currentTarget = $("#"+event.currentTarget.id);
      currentTarget.addClass("active");

      // console.log(currentTarget.find(".livicon-evo")[0])
      // currentTarget.find(".livicon-evo").first().drawLiviconEvo(true);

    },
    mouseOutCard: function(event){
      var that = this;
      var currentTarget = $("#"+event.currentTarget.id);
      currentTarget.removeClass("active");

    }
  },
  mounted:function(){
       var that=this;
      //初始化fullpage
      $('#fp').fullpage({
        anchors: ['About', 'Artist', 'Services',"Contact"],
        navigation: true,
				navigationPosition: 'right',
				// navigationTooltips: ['First page', 'Second page', 'Third and last page','sa'],
        verticalCentered:false,
        scrollOverflow: false,
        offsetSections: false,
				slidesNavigation: true,
        autoscrolling:false,
        allowPageScroll: true,
        scrollBar:false,
        normalScrollElements: ".uk-modal",
        normalScrollElementTouchThreshold: 10,
        afterLoad: function(anchorLink, index){
            var loadedSection = $(this);
            //using index
            that.pageIndex=index;
        }
      });

      that.responseFunc();
      window.addEventListener("resize",that.responseFunc);
  },
  // created:function(){
  //     console.log($("h1").text());
  // }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

  .section .uk-section{
    background: transparent;
  }

  /*section1*/
  .section1 h1{
    color: #5a717c;
    margin-top:30px;
    letter-spacing: 2px;
  }
  .section1 .uk-border-rounded{
    border-radius:20px
  }
  .section1 .uk-card{
    background:transparent
  }
  .section1 .uk-h3{
    margin-top:30px;
    letter-spacing: 4px;
  }
  .uk-heading-line>:after, .uk-heading-line>:before{
    border-bottom: 2px solid #606060;
  }
  .uk-divider-small::after {
    content: "";
    display: inline-block;
    width: 120px;
    max-width: 100%;
    border-top: 4px solid #f95860;
    vertical-align: top;
    /*border-image: linear-gradient(90deg,#FE8155 0,#F95462 35%,#ED7AA3 100%);
    border-image-slice: 1;*/
  }
  /*section2*/
  .section2{
    color:#ffffff;
  }
  .section2 .card-bg  {
    background-image: url('../assets/images/section2-bg.png');
  }
  .section2 .uk-grid .uk-card, .section2 .uk-grid .uk-card:hover{
    background: transparent !important;
    box-shadow:none !important;
  }
   .section2 .uk-h2{
      color:#fff;
      font-size:2.8em;
      letter-spacing: 25px;
   }
   .section2 p{
     color:#ffffff;
     font-size:1.25em;
   }
   .section2 .uk-grid h4{
     color:#ffffff;
      font-weight: 600;
   }
   .section2 .uk-grid .uk-card{
     cursor: pointer;
   }
  .section2 img{
      border: 2px solid #ffffff;
      width: 176px;
   }
  .section2 .uk-grid .uk-card:hover img{
      border: 5px solid #ffffff;
  }
  .section2 .uk-grid .active img{
      border: 5px solid #ffffff;
  }

  /*section3*/
  .section3 h1{
    color: #5a717c;
    margin-top:30px;
    letter-spacing: 16px;
  }
  .section3 .uk-grid2{
    margin-top:20px;
  }
  .section3 .uk-card-hover:hover{
    background:#F2F2F2 !important;
  }

  .section3 .uk-card .uk-card-title{
    color: #787878;
    font-weight:bold;
  }
  .section3 .uk-card.active .uk-card-title{
    color:#5B6E7C;
  }
  .section3 .uk-card p{
    visibility:hidden;
    font-weight:bold;
    transition:all 0.5s ease;
    opacity:0;
    min-height:50px;
  }
  .section3 .uk-card.active p{
    visibility:visible;
    opacity:1; 
    color:#7998AD
  }
  /*section4*/
  .section4 .card-bg{
    background:#BFBFBF
  }
  .section4 h1{
    color: #FDFDFD;
    margin-top:30px;
    letter-spacing: 16px;
  }
  .section4 h4{
    letter-spacing: 2px;
   }
  .section4 p{
    letter-spacing: 3px;
   }
   /*.section4 .uk-inline .uk-card{
     padding-top:120px;
     padding-bottom:120px;
   }*/
   .section4 .position-marker{
     left:42%;
     max-width:70px;
   }
   .section4 .uk-button{
      background:#67889B;
      font-size:15px;
      letter-spacing: 2px;
      font-weight:600;
   }
    .section4 .uk-button:hover{
      background:#8CB2C8;
    }

    
  @media (max-width: 960px){
      .section1 h1 {
        color: #5a717c;
        margin-top: 0px;
        letter-spacing: 1px;
        font-size:1.6rem;
      }
      .section1 .uk-h3 {
          margin-top: 0px;
          letter-spacing: 1px;
         font-size:1.2rem;
      }
      .section2 .uk-h2 {
          color: #fff;
          font-size: 2em;
          letter-spacing: 25px;
          margin-bottom: 10px;
          display:none;
      }
      .section2 p {
          color: #ffffff;
          font-size: 1em;
          margin-top: 10px;
          margin-bottom: 10px;
      }
    .section2 .uk-grid h4{
          margin: 5px !important;
    }

      .section3 h1 {
          margin-top: 0px;
          letter-spacing:5px;
          font-size:1.6rem;
      }
      .section3 .uk-card{
        margin-bottom:15px;
      }
      .section3 .uk-card .uk-card-title {
          color: #787878;
          font-weight: bold;
          font-size:1rem;
      }
     .section3  .uk-card  [class*=uk-align] {
        display: block;
        margin-bottom: 10px;
    }

  .section3 .uk-card.active p{
    visibility:visible;
     display:block;
    opacity:1; 
    color:#7998AD
  }
    .section3 .uk-card p {
      font-size:10px;
      display:none;
      margin:0;
      padding: 4px 2px;
      min-height:0;
    }
    .section3 .uk-grid2 {
          margin-top:0px;
      }

      .section4 h1{
          font-size:2rem;
          margin-top:0 !important;
      }
      .section4 h4 {
          letter-spacing: 1px;
      }
      .section4 .address-card{
          z-index:2;
              padding: 15px;
      }
      .copyright{
        letter-spacing: 1px;
        font-size: 10px;
        margin-top: 5px;
      }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?bfc09a02